// extracted by mini-css-extract-plugin
export var container = "_dj-0";
export var content = "_dj-3";
export var customerTitle = "_dj-4";
export var empty = "_dj-5";
export var gray = "_dj-6";
export var header = "_dj-7";
export var info = "_dj-8";
export var loading = "_dj-2";
export var loadingCard = "_dj-9";
export var oneLine = "_dj-a";
export var personName = "_dj-e";
export var pillContainer = "_dj-b";
export var selected = "_dj-1";
export var text = "_dj-c";
export var twoLines = "_dj-d";
export var unread = "_dj-f";
export var unreadIndicator = "_dj-g";